import { CSS } from 'registration-flow-v2/theme/index';

const BRAND_HERO = '#FFD52E';
const BRAND_ACCENT = '#206E8C';
const PAGE_BG = '#F4F6F8';
const CALLOUT_BG = '#FFFAEA';
const CALLOUT_BORDER = '#F5DC7A';
const CALLOUT_TEXT = '#5C4500';

export const pageRoot: CSS = {
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: PAGE_BG,
};

export const envBanner: CSS = {
  position: 'sticky',
  top: 0,
  zIndex: 100,
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '10px 20px',
  backgroundColor: BRAND_HERO,
  color: '#1c1917',
  fontSize: '13px',
  boxShadow: '0 1px 0 rgba(0,0,0,0.06)',
};

export const envBannerDot: CSS = {
  width: '22px',
  height: '22px',
  borderRadius: '$full',
  backgroundColor: '#000',
  flexShrink: 0,
};

export const envBannerLabel: CSS = {
  fontWeight: 700,
  letterSpacing: '0.02em',
};

export const envBannerDesc: CSS = {
  color: '#44403c',
};

export const content: CSS = {
  flex: 1,
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '40px 40px 0',
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '40px',
  alignItems: 'center',

  '@large': {
    gridTemplateColumns: '1fr 1fr',
    gap: '60px',
  },
};

export const illustrationSide: CSS = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '24px',
};

export const illustrationSvgWrap: CSS = {
  width: '100%',
  maxWidth: '440px',
  '& > svg': {
    width: '100%',
    height: 'auto',
  },
};

export const wordmarkWrap: CSS = {
  textAlign: 'center',
};

export const wordmark: CSS = {
  fontSize: '32px',
  fontWeight: 700,
  color: '#000',
  letterSpacing: '-0.02em',
  lineHeight: 1,
};

export const envLabel: CSS = {
  marginTop: '8px',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  padding: '4px 12px',
  backgroundColor: '#1c1917',
  color: BRAND_HERO,
  borderRadius: '4px',
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
};

export const envLabelDot: CSS = {
  width: '6px',
  height: '6px',
  borderRadius: '$full',
  backgroundColor: BRAND_HERO,
};

export const card: CSS = {
  backgroundColor: '$white',
  borderRadius: '12px',
  padding: '36px 40px',
  boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
};

export const cardHeading: CSS = {
  fontSize: '24px',
  fontWeight: 600,
  margin: '0 0 8px',
  letterSpacing: '-0.01em',
  color: '#000',
};

export const calloutBox: CSS = {
  display: 'flex',
  gap: '10px',
  alignItems: 'flex-start',
  padding: '10px 12px',
  margin: '14px 0 4px',
  backgroundColor: CALLOUT_BG,
  border: `1px solid ${CALLOUT_BORDER}`,
  borderRadius: '8px',
  fontSize: '13px',
  lineHeight: 1.5,
  color: CALLOUT_TEXT,
};

export const calloutLink: CSS = {
  color: BRAND_ACCENT,
  fontWeight: 600,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
};

export const footerLinks: CSS = {
  width: '100%',
  padding: '28px 40px 24px',
  display: 'flex',
  justifyContent: 'center',
  gap: '24px',
  fontSize: '13px',
  color: '#78716c',

  '& a': {
    color: '#78716c',
    textDecoration: 'none',
    '&:hover': {
      color: '#1c1917',
      textDecoration: 'underline',
    },
  },
};
